import React, { Component } from 'react';
//import 'fullcalendar/dist/fullcalendar.print.min.css';
import 'fullcalendar/dist/fullcalendar.js';
import {firebaseDb} from '../lib/firebase/firebase';
import {
  formatDate,
  formatTime, 
  validateEmail,
} from '../utils/lib';
var SHA256 = require("crypto-js/sha256");

class ClientInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noteText:'',
    };
  }

  componentDidMount(){
    var _self = this;
    if(this.props.client){
      _self.setState({client:this.props.client})
    }else{
      firebaseDb.ref("clients/" + this.props.clientId).once('value',function(snap){
        _self.setState({client:snap.val()})
      })
    }
  }

  render(){
    if(this.state.client){
      return (
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><span className="glyphicon glyphicon-user" aria-hidden="true"></span> {this.state.client.name}</p>
            </div>
            <div className="col-md-6" style={{textAlign:'right'}}>
              <p>{this.state.client.phone} <span className="glyphicon glyphicon-earphone" aria-hidden="true"></span></p>
              <p>{this.state.client.email} <span className="glyphicon glyphicon-envelope" aria-hidden="true"></span></p>
            </div>
          </div>
        </div>
      );
    }else{
      return (
        <div>
          <h4>Loading reservation</h4>
          <p>...</p>
        </div>
      );
    }
  }
}
// Specifies the default values for props:
ClientInfo.defaultProps = {
  onClear:()=>console.log('Clear form'),
}
class ReservationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noteText:'',
    };
  }

  componentDidMount(){
    var _self = this;
    if(this.props.reservation){
      this.setState({reservation:this.props.reservation})
    }else{
      firebaseDb.ref("reservations/" + this.props.reservationId).on('value',function(snap){
        _self.setState({reservation:snap.val()})
      })
    }
  }
  componentWillUnmount(){
    firebaseDb.ref("reservations/" + this.props.reservationId).off()
  }
  handleChangeNote(event) {
    var noteText = this.state.noteText;
    noteText["noteText"]=event.target.value;
    this.setState({noteText});
  }

  handleCreateNote(event) {
    if(this.state.noteText!=''){
      var note = {
        created_by:this.props.user.id,
        created_at:(new Date()).toISOString(),
        text:this.state.noteText,
      }
      var key = firebaseDb.ref("reservations/" + this.props.reservationId + "/notes").push(note).key;
      var reservation = this.state.reservation;
      reservation["notes"] = reservation["notes"]?reservation["notes"]:{};
      reservation["notes"][key] = note;
      this.setState({message:{type:"success",text:"Note created successfully!",reservation:reservation}},this.clearForm.bind(this))
    }else{
      this.setState({message:{type:"danger",text:'Invalid note.'}})
    }
  }

  clearForm(){
    this.setState({
      noteText:"",
    },this.props.onClear);
  }
  handleChangeNotes(event) {
    this.setState({noteText: event.target.value});
  }
  getNotes(){
    var items = [];
    for(var n in this.state.reservation.notes){
      items.push(
        <div style={{paddingBottom:5,}} className="list-group-item">
          <div className="row">
            <div className="col-md-12">
              {this.state.reservation.notes[n].text}
            </div>
            <div className="col-md-12">
              <small className="pull-right">{(new Date(this.state.reservation.notes[n].created_at)).toLocaleTimeString()}</small>
            </div>
          </div>
        </div>
      );
    }
    if(items.length>0){
      items = (
        <div className="list-group">
          {items}
        </div>
      );
    }
    return items;
  }

  getStaff(){
    var items = [];
    if(this.state.reservation&& this.state.reservation.asignee){
      items = (
        <span style={{cursor:'pointer',textDecorationLine:'none',borderRadius:5,padding:5,color:'#FFFFFF',backgroundColor:(this.props.staff?this.props.staff[this.state.reservation.asignee].color:"#FFFFFF")}}>{this.props.staff[this.state.reservation.asignee].name}</span>
      );
    }
    if(items.length===0){
      items.push(
        <span id={"no-data"} key={"no-data"}>No asignee</span>
      );
    }
    return items;
  }

  getTags(){
    var items = [];
    var tags = this.state.reservation?this.state.reservation.tags:{};
    for(var u in tags){
      items.push(
        <span style={{cursor:'pointer',textDecorationLine:'none',borderRadius:5,padding:5,color:'#FFF',backgroundColor:'#888'}}>{this.props.tags[u].name}</span>
      );
    }
    if(items.length===0){
      items.push(
        <span id={"no-data"} key={"no-data"}>No tags</span>
      );
    }
    return items;
  }

  render() {
    if(this.state.reservation){
      var tags = this.getTags();
      var asignee = this.getStaff();
      var notes = this.getNotes()
      return(
        <div>
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-12">
                  <h3 style={{marginTop:10,}}>{this.props.categories[this.state.reservation.category].name}</h3>
                </div>
                <div className="col-md-12">
                  <h4>{this.props.categories[this.state.reservation.category].sub_categories[this.state.reservation.sub_category].name}</h4>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row text-right">
                <div className="col-md-12">
                  {(new Date(this.state.reservation.start_datetime)).toDateString()}
                </div>
                <div className="col-md-12">
                  {(new Date(this.state.reservation.start_datetime)).toLocaleTimeString()}
                </div>
                <div className="col-md-12">
                  {(new Date(this.state.reservation.end_datetime)).toLocaleTimeString()}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <ClientInfo user={this.props.user} clientId={this.state.reservation.client}/>
          {notes}
          <div className="row">
            <div className="col-md-12">
              <textarea 
                id="notes" 
                name="notes" 
                value={this.state.noteText}
                onChange={this.handleChangeNotes.bind(this)}
                style={{color:'#484848'}}
                className="form-control"
                rows="3"
                placeholder="Reservation notes here...">
              </textarea>
            </div>
            <div className="col-md-12">
              <a className="btn btn-default btn-sm pull-right" style={{marginTop:10,}} onClick={this.handleCreateNote.bind(this)}>
                SEND
              </a>
            </div>
          </div>
          <div>{asignee} {tags}</div>
        </div>
      );   
    }
    return (
      <div>
        <h4>Loading reservation</h4>
        <p>...</p>
      </div>
    );
  }
}
// Specifies the default values for props:
ReservationDetail.defaultProps = {
  selectedDateRange:{
    start:"",
    end:"",
  },
  onClear:()=>console.log('Clear form'),
}
export default ReservationDetail;


// WEBPACK FOOTER //
// ./src/components/ReservationDetail.js